import { render, staticRenderFns } from "./RBreadcrumb.vue?vue&type=template&id=d08fa618&scoped=true&"
import script from "./RBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./RBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./RBreadcrumb.vue?vue&type=style&index=0&id=d08fa618&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08fa618",
  null
  
)

export default component.exports